import { IActivityScheduleBase } from '../../models/activities';
import {
  IBookingBase,
  IBookingCancellationHistoryBase,
  IBookingPaymentBase,
} from '../../models/bookings';
import { IUserBase } from '../../models/users';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListBookingCancellationHistoriesProps {
  maxDate?: Date;
  minDate?: Date;
  limit?: number;
  userDocument?: string;
  userName?: string;
  sort?: 'minutesBeforeScheduleStart' | 'createdAt';
  order?: 'ASC' | 'DESC';
  page?: number;
}

interface ICancellationHistoryBooking extends IBookingBase {
  user: IUserBase;
  activitySchedule: IActivityScheduleBase;
  payment: IBookingPaymentBase;
}

export interface IBookingCancellationHistoryListItem
  extends IBookingCancellationHistoryBase {
  user: IUserBase;
  booking: ICancellationHistoryBooking;
}

export const listBookingCancellationHistoriesService = async ({
  order,
  sort,
  userDocument,
  userName,
  limit,
  maxDate,
  minDate,
  page,
}: IListBookingCancellationHistoriesProps): Promise<
  IListResponse<IBookingCancellationHistoryListItem>
> => {
  const { data } = await jhsfBookingsApi.get<
    IListResponse<IBookingCancellationHistoryListItem>
  >('/bookings/cancellation-histories', {
    params: {
      order,
      sort,
      userDocument,
      userName,
      limit,
      maxDate,
      minDate,
      page,
    },
  });

  return data;
};
